import React from "react"

import {
    GridCell,
} from "@bdfx/mergado-ui-kit"

import trans from "trans"

import { StyledToggler, StyledSliderDiv } from './common-shape-form';
import { Slider } from "@mui/material";

const { min, max, abs, sin, cos, PI, round, atan2, sqrt, ceil } = Math

const ReflectionForm = ({ shape, formName, activeShapeId, change }) => {
    const maxSide = max(shape.width, shape.height)
    return (
        <React.Fragment>
            <GridCell>{trans('has_reflection')}</GridCell>
            <GridCell style={{textAlign: 'right', alignSelf: 'center'}}>
                <StyledToggler
                    value={!!shape.has_reflection}
                    onChange={(e: any) => {
                        if (e) {
                            const newShape = {
                                ...shape,
                                has_reflection: true,
                                reflection_angle: 0,
                                reflection_offset: 0,
                                reflection_opacity: 50,
                            }
                            change(formName, `shapes.${activeShapeId}`, newShape)
                        } else {
                            const newShape = {
                                ...shape,
                                has_reflection: null,
                                reflection_angle: null,
                                reflection_offset: null,
                                reflection_opacity: null,
                            }
                            change(formName, `shapes.${activeShapeId}`, newShape)
                        }
                    }}
                />
            </GridCell>

            {shape.has_reflection ?
                <>
                    <GridCell>{trans('reflection_angle')}</GridCell>
                    <GridCell>
                        <StyledSliderDiv>
                            <Slider
                                value={round(shape.reflection_angle || 0)}
                                onChange={(event: Event, value: number) => change(formName, `shapes.${shape.index}.reflection_angle`, value)}
                                min={-90}
                                max={90}
                                step={1}
                                valueLabelDisplay="on"
                                getAriaLabel={() => trans('reflection_angle')}
                                getAriaValueText={(value) => `${value}`}
                                valueLabelFormat={(value) => `${value}`}
                            />
                        </StyledSliderDiv>
                    </GridCell>

                    <GridCell>{trans('reflection_offset')}</GridCell>
                    <GridCell>
                        <StyledSliderDiv>
                            <Slider
                                value={round(shape.reflection_offset || 0)}
                                onChange={(event: Event, value: number) => change(formName, `shapes.${shape.index}.reflection_offset`, value)}
                                min={-maxSide}
                                max={maxSide}
                                step={10}
                                valueLabelDisplay="on"
                                getAriaLabel={() => trans('reflection_offset')}
                                getAriaValueText={(value) => `${value}`}
                                valueLabelFormat={(value) => `${value}`}
                            />
                        </StyledSliderDiv>
                    </GridCell>

                    <GridCell>{trans('reflection_opacity')}</GridCell>
                    <GridCell>
                        <StyledSliderDiv>
                        <Slider
                            value={round(shape.reflection_opacity || 0)}
                            onChange={(event: Event, value: number) => change(formName, `shapes.${shape.index}.reflection_opacity`, value)}
                            min={0}
                            max={100}
                            step={1}
                            valueLabelDisplay="on"
                            getAriaLabel={() => trans('reflection_opacity')}
                            getAriaValueText={(value) => `${value}`}
                            valueLabelFormat={(value) => `${value}`}
                        />
                        </StyledSliderDiv>
                    </GridCell>

                    <GridCell>{trans('reflection_flip')}</GridCell>
                    <GridCell>
                        <StyledToggler
                            value={!!shape.reflection_flip}
                            onChange={(e) => {
                                change(formName, `shapes.${activeShapeId}.reflection_flip`, e)
                            }}
                        />
                    </GridCell>
                </> :
                <GridCell col={'1/-1'} />
            }
        </React.Fragment>
    )
}

export default ReflectionForm